module.exports = require("electron");


//////////////////
// WEBPACK FOOTER
// external "electron"
// module id = electron
// module chunks = 3